import React from "react";
import { node } from "prop-types";
import { Col } from "../Grid";

const TopBarLogo = ({ children }) => (
	<Col shrink spacing={{ mr: 12, mt: 1 }}>
		{children}
	</Col>
);

TopBarLogo.propTypes = {
	children: node.isRequired,
};

export default TopBarLogo;
